import { getLocalStorageAuthToken, setLocalStorageAuthToken, clearLocalStorage, } from './localStorage';
import { clearSessionStorage, getSessionStorageAuthToken, setSessionStorageAuthToken, } from './sessionStorage';
export const storageHandler = (browserCacheType = 'localStorage') => {
    if (browserCacheType === 'localStorage') {
        return {
            clean: clearLocalStorage,
            getAuthToken: getLocalStorageAuthToken,
            setAuthToken: setLocalStorageAuthToken,
        };
    }
    return {
        clean: clearSessionStorage,
        getAuthToken: getSessionStorageAuthToken,
        setAuthToken: setSessionStorageAuthToken,
    };
};
//# sourceMappingURL=storageHandler.js.map